// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qBzL","rootMobile":"styles_rootMobile__ZSh0K"};